import { lazy } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Box } from '@mui/material'
import { Navigation } from '@/Entities/App/Navigation'

const BucketAdminPage = lazy(() => import('@/Pages/BucketAdminPage'))
const BrowseObjectsPage = lazy(() => import('@/Pages/BrowseObjectsPage'))
const BucketListPage = lazy(() => import('@/Pages/BucketListPage'))
const HomePage = lazy(() => import('@/Pages/HomePage'))

export const AppRouter = () => {
    return (
        <Router>
            <Box display="flex" flexDirection="row" minHeight="100vh">
                <Navigation />
                <Box flex="0 0 calc(100vw - 270px)" maxWidth="calc(100vw - 270px)">
                    <Routes>
                        <Route path="/buckets" element={<BucketListPage />} />
                        <Route path="/buckets/:name/admin" element={<BucketAdminPage />} />
                        <Route path="/buckets/:bucketName/browse" element={<BrowseObjectsPage />} />
                        <Route
                            path="/buckets/:bucketName/browse/:path"
                            element={<BrowseObjectsPage />}
                        />
                        <Route path="/" element={<HomePage />} />
                    </Routes>
                </Box>
            </Box>
        </Router>
    )
}
